import { PERMISSIONS } from '@/shared/const/permissions.const';
import { useQueryState } from 'nuqs';
import { useCallback } from 'react';
import { useAuth } from '../useAuth/useAuth';

export function usePermissions() {
  const { hasPermission } = useAuth();

  const isQa = location.hostname.includes('front');
  const [testingMode] = useQueryState('testingMode');

  const can = useCallback(
    (perm: string) => hasPermission(perm),
    [hasPermission],
  );
  const canAny = useCallback(
    (perms: string[]) => perms.some(hasPermission),
    [hasPermission],
  );
  const canAll = useCallback(
    (perms: string[]) => perms.every(hasPermission),
    [hasPermission],
  );

  const canApplicationCheckActions =
    can(PERMISSIONS.APPLICATIONS.DOCUMENT_APPROVE) &&
    can(PERMISSIONS.APPLICATIONS.DOCUMENT_REJECT) &&
    can(PERMISSIONS.APPLICATIONS.STORE_OPTION_LIST);

  const canAttachEmployee = can(PERMISSIONS.APPLICATIONS.ATTACH_EMPLOYEE);

  const canCreateCreditApplication = can(PERMISSIONS.LOANS.CREATE);

  const isDownloadMonitoringRegionRequired = can(
    PERMISSIONS.MONITORING.DOWNLOAD_REGION,
  );

  return {
    canApplicationCheckActions,
    canCreateCreditApplication,
    canAttachEmployee,
    isQa,
    testingMode,
    can,
    canAny,
    canAll,
    isDownloadMonitoringRegionRequired,
  };
}
